{
  "clear": "Išvalyti",
  "invalid": "(netinkama)",
  "loading": "Įkeliama...",
  "noResults": "Rezultatų nėra"
}
